export const staticData = {
  step1: {
    selectDataYourAge: [
      { value: '18-20', title: '18-20 år' },
      { value: '21-24', title: '21-24 år' },
      { value: '25-29', title: '25-29 år' },
      { value: '30', title: '> 30 år' }
    ],
    selectDataVehicleValueNew: [
      { value: '119999', title: 'Personbil < 120.000' },
      { value: '169999', title: 'Personbil 120.000 - 169.999' },
      { value: '249999', title: 'Personbil 170.000 - 249.999' },
      { value: '374999', title: 'Personbil 250.000 - 374.999' },
      { value: '494999', title: 'Personbil 375.000 - 494.999' },
      { value: '594999', title: 'Personbil 495.000 - 594.999' },
      { value: '724999', title: 'Personbil 595.000 - 724.999' },
      { value: 'van-120000', title: 'Varebil til privat brug 0 – 120.000' },
      { value: 'van-169999', title: 'Varebil til privat brug 120.000 - 169.999' },
      { value: 'van-249999', title: 'Varebil til privat brug 170.000 - 249.999' },
      { value: 'van-374999', title: 'Varebil til privat brug 250.000 - 374.999' },
      { value: 'van-494999', title: 'Varebil til privat brug 375.000 - 494.999' },
      { value: 'van-594999', title: 'Varebil til privat brug 495.000 - 594.999' },
      { value: 'van-724999', title: 'Varebil til privat brug 595.000 - 724.999' },
    ]
  },
  step2: {
    ownRisk(that){
      var deductible =
        that.app && that.app.insApiCallback ? that.app.insApiCallback.state.data.deductible : 0;
      return {
        value: 'OwnRisk10000',
        title: 'Selvrisiko på ' + deductible.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
        checked: true
      }
    },
    checklistData: [
      { value: 'Post_no_neutral', title: 'Post nr. neutral', checked: true },
      { value: 'No_HK_limitation ', title: 'Ingen HK begrænsning', checked: true },
      { value: 'Frikm', title: 'Fri km', checked: true },
      { value: 'FaultTankCoverage ', title: 'Fejltanksdækning', checked: true },
      { value: 'Comprehensive', title: 'Kasko', checked: true },
      { value: 'Liability', title: 'Ansvar', checked: true }
    ],
    checkboxListData(that) {

      var parking_price = ()=>{
        return Math.round((that.app.price * 0.20) / 12).toFixed(0) + ',-';
      }

      var damageConverage_price = ()=>{
        return Math.round((that.app.price * 0.08) / 12).toFixed(0) + ',-';
      }

      var fromYearPrice = (price)=>{
        return Math.round( price / 12).toFixed(0) + ',-';
      }

      // var includeDeductibleCoverage_price = function() {
        
      //   switch (that.ins.age) {
      //     case 20:
      //       return '70,-';
      //     case 24:
      //     case 29:
      //       return '65,-';
      //     case 30:
      //       return '58,-';
      //     default:
      //       return 'ukendt';
      //   }
      // };


      var includeRoadAssistance_price = function() {
        let carAge = that.ins.carAge || 0;
        let price =  442 / 12;
        if (carAge <= 5) {
          price = 442 / 12;
        } else if (carAge >= 6 && carAge <= 9) {
          price = 553 / 12;
        } else if (carAge >= 10) {
          price = 885 / 12;
        }
        // round up price to nearest full number
        price = Math.ceil(price);
        return price + ',-';
      };


      return [
         {
          value: 'driverCoverage',
          checked: that.ins.driverCoverage,
          title: 'Førerpladsdækning',
          price: fromYearPrice(272),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },

  {
          value: 'youngDriver',
          checked: that.ins.youngDriver,
          title: 'Ung Fører',
          price: fromYearPrice(333),
          priceNote: 'Pr. Md.',
          helpTitle: 'Ung Fører',
          helpTextHtml: '<p>Hvis du har hjemmeboende børn, kan du tilkøbe denne dækning, så dine hjemmeboende børn optjener anciennitet til når de skal have egen bil. Desuden slipper du for at betale dobbelt selvrisiko, hvis en skade laves af et hjemmeboende barn under 25 år.</p>'
        },
  {
          value: 'glass',
          checked: that.ins.glass,
          title: 'Glas Plus',
          price: fromYearPrice(769),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },

  {
          value: 'parking',
          checked: that.ins.parking,
          title: 'Parkering Plus',
          price: parking_price(),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },

 {
          value: 'damageConverage',
          checked: that.ins.damageConverage,
          title: 'Friskadedækning',
          price: damageConverage_price(),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },

{
          value: 'rentalPlus',
          checked: that.ins.rentalPlus,
          title: 'Lånebil Plus',
          price: fromYearPrice(173),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },
        {
          value: 'leasingBasis',
          checked: that.ins.leasingBasis,
          title: 'Leasing Basis',
          price: fromYearPrice(452),
          priceNote: 'Pr. Md.',
          helpTitle: '',
          helpTextHtml: ''
        },    
        {
          value: 'includeRoadAssistance',
          checked: that.ins.includeRoadAssistance,
          title: 'Autohjælp',
          price: includeRoadAssistance_price(),
          priceNote: 'Pr. Md.',
          helpTitle: 'Autohjælp',
          helpTextHtml:
            '<p>Hurtig hjælp, hvis uheldet er ude. Vi samarbejder med SOS Dansk Autohjælp, som kommer dig til undsætning, hvis du ikke kan køre videre i din bil.</p>'
        },
      ];
    }
  },
  step3: {}
};
